export enum LandingEndPoints {
   Contacts = '/contacts',
   NewsLetter = '/contacts/notify',
}